// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon, type IconProps } from '../BaseIcon'
import { rtlFlipCss } from '../iconStyles'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path
      d="M22 3a1 1 0 0 0-1-1l1 1Zm-1-1H3c-.54.04-.96.46-1 1v18c.04.54.46.96 1 1h18c.54-.04.96-.46 1-1V3a1.08 1.08 0 0 0-1-1Zm-6 13h-2v2h2v3H4v-3h2v-2H4V4h11v11Zm5 5h-3V4h3v16ZM8 15h3v2H8v-2Z"
      className={rtlFlipCss}
    />
  </BaseIcon>
)
